import { useCallback, useState } from "react";
import { useSelector } from "react-redux";
import { Link, useParams } from "react-router-dom";
import { selectPortalContext } from "../../../../store/slice/portalContextSlice";
import { CompanyLogo, Search, Setting, ShoppingCart } from "../../assets/icons";
import { PortalAccountPopup } from "../../components/PortalAccountPopup/PortalAccountPopup";
import {
  usePortalCurrencySymbol,
  usePortalFormattedAmount,
} from "../../hooks/usePortalFormattedAmount";
import {
  StyledCatalogueTopbarCartContainerDiv,
  StyledCatalogueTopbarContainerDiv,
  StyledCatalogueTopbarLeftDiv,
  StyledCatalogueTopbarRightDiv,
  StyledCircleIconDiv,
  StyledIconContainerDiv,
  StyledSearchContainerDiv,
} from "./Topbar.styles";

export const Topbar = ({
  searchValue,
  onSearchChange,
  cartItemCount,
  cartTotal,
  showSearch = true,
  placeholder,
}) => {
  const { subdomain } = useParams();
  const portalContext = useSelector(state => selectPortalContext(state, subdomain));
  const formatAmount = usePortalFormattedAmount();
  const currencySymbol = usePortalCurrencySymbol();

  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const handleClosePopup = useCallback(() => setIsPopupOpen(false), []);

  return (
    <StyledCatalogueTopbarContainerDiv>
      <StyledCatalogueTopbarLeftDiv>
        <h2 className="headerH2">
          <StyledIconContainerDiv>
            <CompanyLogo />
          </StyledIconContainerDiv>
          {portalContext?.name || "Company Portal"}
        </h2>

        {showSearch && (
          <StyledSearchContainerDiv>
            <input
              placeholder={placeholder || "Search by product code or description..."}
              value={searchValue}
              onChange={e => onSearchChange(e.target.value)}
            />
            <Search />
          </StyledSearchContainerDiv>
        )}
      </StyledCatalogueTopbarLeftDiv>

      <StyledCatalogueTopbarRightDiv>
        <StyledCatalogueTopbarCartContainerDiv as={Link} to={`/portal/${subdomain}/cart`}>
          <ShoppingCart />
          <span>
            Cart
            {cartTotal > 0 &&
              ` - ${currencySymbol}
            ${formatAmount(cartTotal)}`}
          </span>
          <StyledCircleIconDiv>{cartItemCount}</StyledCircleIconDiv>
        </StyledCatalogueTopbarCartContainerDiv>

        <div style={{ position: "relative", display: "flex", alignItems: "center" }}>
          <div
            onClick={() => setIsPopupOpen(true)}
            style={{ cursor: "pointer", display: "flex", alignItems: "center" }}
          >
            <Setting />
          </div>
          {isPopupOpen && (
            <PortalAccountPopup styleOfModal={popupStyle} closeModal={handleClosePopup} />
          )}
        </div>
      </StyledCatalogueTopbarRightDiv>
    </StyledCatalogueTopbarContainerDiv>
  );
};

const popupStyle = {
  position: "absolute",
  top: "100%",
  right: 0,
  marginTop: "12px",
  zIndex: 11,
};
